<template>
  <div>
    <div class="bg-white box-content mt-3">
      <table class="table">
        <thead>
          <tr>
            <th rowspan="2">Month</th>
            <!-- <th colspan="4" class="brg">Total</th>
            <th colspan="4" class="brg">Cahaya</th>
            <th colspan="4">Menara</th> -->
          </tr>
          <tr>
            <th id="slm-total-po-1">
              PO
              <b-popover
                target="slm-total-po-1"
                triggers="hover"
                placement="top"
              >
                <template #title>PO</template>
                <div v-html="tooltip.slm_po"></div>
              </b-popover>
            </th>
            <th id="slm-total-scan-1">
              Scan
              <b-popover
                target="slm-total-scan-1"
                triggers="hover"
                placement="top"
              >
                <template #title>Scan</template>
                <div v-html="tooltip.slm_scan"></div>
              </b-popover>
            </th>
            <th id="slm-active-qr-1">
              Active QR
              <b-popover
                target="slm-active-qr-1"
                triggers="hover"
                placement="top"
              >
                <template #title>Total Active QR</template>
                <div v-html="tooltip.slm_total_active_qr"></div>
              </b-popover>
            </th>
            <th id="slm-qr-code-1">
              QR Code
              <b-popover
                target="slm-qr-code-1"
                triggers="hover"
                placement="top"
              >
                <template #title>Total QRCode</template>
                <div v-html="tooltip.slm_total_qr_code"></div>
              </b-popover>
            </th>
            <!-- <th id="slm-total-po-2">
              PO
              <b-popover
                target="slm-total-po-2"
                triggers="hover"
                placement="top"
              >
                <template #title>PO</template>
                <div v-html="tooltip.slm_po"></div>
              </b-popover>
            </th>
            <th id="slm-total-scan-2">
              Scan
              <b-popover
                target="slm-total-scan-2"
                triggers="hover"
                placement="top"
              >
                <template #title>Scan</template>
                <div v-html="tooltip.slm_scan"></div>
              </b-popover>
            </th>
            <th id="slm-active-qr-2">
              Active QR
              <b-popover
                target="slm-active-qr-2"
                triggers="hover"
                placement="top"
              >
                <template #title>Total Active QR</template>
                <div v-html="tooltip.slm_total_active_qr"></div>
              </b-popover>
            </th>
            <th class="brg" id="slm-qr-code-2">
              QR Code
              <b-popover
                target="slm-qr-code-2"
                triggers="hover"
                placement="top"
              >
                <template #title>Total QRCode</template>
                <div v-html="tooltip.slm_total_qr_code"></div>
              </b-popover>
            </th>
            <th id="slm-total-po-3">
              PO
              <b-popover
                target="slm-total-po-3"
                triggers="hover"
                placement="top"
              >
                <template #title>PO</template>
                <div v-html="tooltip.slm_po"></div>
              </b-popover>
            </th>
            <th id="slm-total-scan-3">
              Scan
              <b-popover
                target="slm-total-scan-3"
                triggers="hover"
                placement="top"
              >
                <template #title>Scan</template>
                <div v-html="tooltip.slm_scan"></div>
              </b-popover>
            </th>
            <th id="slm-active-qr-3">
              Active QR
              <b-popover
                target="slm-active-qr-3"
                triggers="hover"
                placement="top"
              >
                <template #title>Total Active QR</template>
                <div v-html="tooltip.slm_total_active_qr"></div>
              </b-popover>
            </th>
            <th id="slm-qr-code-3">
              QR Code
              <b-popover
                target="slm-qr-code-3"
                triggers="hover"
                placement="top"
              >
                <template #title>Total QRCode</template>
                <div v-html="tooltip.slm_total_qr_code"></div>
              </b-popover>
            </th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="dat in data" v-if="data.length > 0">
            <td>{{ monthNames[dat.month - 1] }}</td>
            <td>{{ numberWithCommas(dat.total_po) }}</td>
            <td>{{ numberWithCommas(dat.total_scan) }}</td>
            <td>{{ numberWithCommas(dat.total_active) }}</td>
            <td class="total-qr">{{ numberWithCommas(dat.total_qr) }}</td>
            <!-- <td>{{ numberWithCommas(dat.CAHAYA_total_po) }}</td>
            <td>{{ numberWithCommas(dat.CAHAYA_total_scan) }}</td>
            <td>{{ numberWithCommas(dat.CAHAYA_total_active) }}</td>
            <td class="brg">{{ numberWithCommas(dat.CAHAYA_total_qr) }}</td>
            <td>{{ numberWithCommas(dat.MENARA_total_po) }}</td>
            <td>{{ numberWithCommas(dat.MENARA_total_scan) }}</td>
            <td>{{ numberWithCommas(dat.MENARA_total_active) }}</td>
            <td>{{ numberWithCommas(dat.MENARA_total_qr) }}</td> -->
          </tr>
          <!-- <tr v-if="totalYear">
            <td class="brg font-weight-bold">Total</td>
            <td>{{ numberWithCommas(totalYear.total_po) }}</td>
            <td>{{ numberWithCommas(totalYear.total_scan) }}</td>
            <td>{{ numberWithCommas(totalYear.total_active) }}</td>
            <td class="brg">{{ numberWithCommas(totalYear.total_qr) }}</td>
            <td>{{ numberWithCommas(totalYear.CAHAYA_total_po) }}</td>
            <td>{{ numberWithCommas(totalYear.CAHAYA_total_scan) }}</td>
            <td>{{ numberWithCommas(totalYear.CAHAYA_total_active) }}</td>
            <td class="brg">
              {{ numberWithCommas(totalYear.CAHAYA_total_qr) }}
            </td>
            <td>{{ numberWithCommas(totalYear.MENARA_total_po) }}</td>
            <td>{{ numberWithCommas(totalYear.MENARA_total_scan) }}</td>
            <td>{{ numberWithCommas(totalYear.MENARA_total_active) }}</td>
            <td>{{ numberWithCommas(totalYear.MENARA_total_qr) }}</td>
          </tr> -->
        </tbody>
      </table>

      <!-- {{data}} -->
      <!-- <vue-universal-table
                api_url="/api/reports/summary-labelmaker?year=2022"
                :pagination="false"
                :process_data="vue_universal_table.process_data"
                :fields="vue_universal_table.fields"

                sort_order="DESC"
                sort_by="id"
            ></vue-universal-table> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      tooltip: this.$store.state.tooltip.reports.summary_report.sum_label_maker,
      monthNames: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ],
      // moment : moment,
      // dummyData : null,
      totalYear: null,
      // vue_universal_table : {
      //     fields : [
      //         {title:"Month", variable:"month_name"},
      //         {title:"Cahaya Jumlah PO", variable:"CAHAYA_total_po", number_formatting:true},
      //         {title:"Cahaya Jumlah Scan", variable:"CAHAYA_total_scan", number_formatting:true},
      //         {title:"Cahaya Jumlah QR Active", variable:"CAHAYA_total_active", number_formatting:true},
      //         {title:"Cahaya Jumlah QR Code", variable:"CAHAYA_total_qr", number_formatting:true},
      //         {title:"Menara Jumlah PO", variable:"MENARA_total_po", number_formatting:true},
      //         {title:"Menara Jumlah Scan", variable:"MENARA_total_scan", number_formatting:true},
      //         {title:"Menara Jumlah QR Active", variable:"MENARA_total_active", number_formatting:true},
      //         {title:"Menara Jumlah QR Code", variable:"MENARA_total_qr", number_formatting:true},
      //     ],
      //     // filter : {},
      //     update : 0,
      //     process_data : `
      //         let totalYear = {month: 'Total' , month_name : 'Total'};

      //         for (var i = 0; i < data.length; i++) {
      //             // console.log(data[i].month)
      //             data[i].month_name = new this.moment().set("month", data[i].month - 1).format('MMM')
      //             // console.log(data[i].month_name )

      //             for (var j in data[i]) {
      //                 if (j == 'month' || j == 'month_name') continue;

      //                 if (totalYear[j] == null) {
      //                     totalYear[j] = parseInt(data[i][j]);
      //                 } else {
      //                     totalYear[j] += parseInt(data[i][j]);
      //                 }
      //             }
      //         }

      //         data.push(totalYear)
      //     `
      // }
    };
  },
  props: ["data"],
  mounted() {
    // this.generateDummyData();
    this.total();
  },
  methods: {
    async total() {
      // let resp = await this.$http.get('/api/reports/summary-labelmaker?year=2022')
      let data = this.data;
      let totalYear = { month: "Total" };

      for (var i = 0; i < data.length; i++) {
        // this.$set(data[i] , 'month_name' ,new moment().set("month", data[i].month - 1).format('MMM') )
        // console.log(data[i])

        // let keys = Object.keys(data[i])

        for (var j in data[i]) {
          if (j == "month") continue;

          if (totalYear[j] == null) totalYear[j] = 0;

          totalYear[j] += parseInt(data[i][j]);
        }
      }
      // data.push(totalYear)
      this.totalYear = totalYear;

      console.log(totalYear);
    },
  },
};
</script>

<style scoped>
td {
  border-top: 0;
}

.table:not(.table-bordered) thead tr th {
    border-top: 1px solid #b8c1ca;
    font-weight: 400;
}

.total-qr {
  width: 150px;
}
/* tbody {
        display: block;
        max-height: 65vh;
        overflow-y: scroll;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
        width: calc(100% - 10px);
    }

    thead tr th {
        border-bottom: 0.5px solid #FF0009;
        font: normal normal 500 14px/16px Ubuntu;
        color: #707070;
    }

    tbody tr td {
        font: normal normal 500 13px/14px Ubuntu;
        color: #707070;
        word-wrap: break-word;
    }

    thead tr th,
    tbody tr td {
        vertical-align: middle;
    }

    tbody tr td {
        border-top: 0;
    }

    tbody tr.border-top td:not(:first-child) {
        border-top: 1px solid #d6dadd;
    } */

.detailStockTable::-webkit-scrollbar {
  width: 10px;
}
.detailStockTable::-webkit-scrollbar-track {
  background-color: white;
  border-radius: 20px;
}
.detailStockTable::-webkit-scrollbar-thumb {
  background-color: #f1f1f1;
  border-radius: 20px;
}

table th,
table td {
  /* text-align: center; */
  vertical-align: middle;
  
}

table thead th {
  color: #707070;
}

table tbody td {
  color: #707070;
}

.brg {
  border-right: 1px dotted #b8c1ca;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9D9D9D;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4B4B4B;
  text-align: left;
  vertical-align: middle;
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}
</style>
